// extracted by mini-css-extract-plugin
module.exports = {"container":"e_qC","label":"e_rC","image":"e_sC","name":"e_tC","description":"e_uC","descriptionCollapsed":"e_vC","bottomLine":"e_wC","socialIcon":"e_xC"};